import { CitationAttributes } from './citation-extension'

/**
 * Validate if a Citation node has complete navigation data
 * Citations are ONLY for internal documents
 */
export function validateCitationAttrs(attrs: CitationAttributes): boolean {
  if (!attrs) return false
  
  // Citations must be internal documents with navigation data
  // Must have either slug or docId for navigation
  return !!(attrs.slug || attrs.docId)
}

/**
 * Get warning message for incomplete or broken citations
 */
export function getCitationWarning(attrs: CitationAttributes): string | null {
  if (!attrs) return 'Citation data is missing'
  
  // Check for broken links first
  if (attrs.isBrokenLink) {
    return 'Reference target may have been deleted or moved'
  }
  
  // Check for incomplete references (all citations are internal)
  if (!attrs.slug && !attrs.docId) {
    return 'Reference is incomplete - navigation information is missing'
  }
  
  return null
}

/**
 * Determine if citation should be displayed as clickable
 */
export function isCitationClickable(attrs: CitationAttributes): boolean {
  if (!validateCitationAttrs(attrs)) return false
  if (attrs.isBrokenLink) return false
  
  // Citations are only for internal docs, need at least slug or docId
  return !!(attrs.slug || attrs.docId)
}

/**
 * Get CSS classes for citation based on its state
 */
export function getCitationClassName(
  attrs: CitationAttributes,
  selected: boolean = false
): string {
  const classes: string[] = ['citation-node']
  
  if (selected) {
    classes.push('ProseMirror-selectednode')
  }
  
  const warning = getCitationWarning(attrs)
  const clickable = isCitationClickable(attrs)
  
  if (clickable) {
    classes.push('citation-clickable')
  } else if (warning) {
    classes.push('citation-incomplete')
  }
  
  if (attrs.isBrokenLink) {
    classes.push('citation-broken')
  }
  
  return classes.join(' ')
}